import { Controller } from "@hotwired/stimulus"

// Shows the "no classes associated with this plan" overlay when student clicks Free on a plan.
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this.boundCloseOnBackdrop = this.closeOnBackdrop.bind(this)
  }

  open(event) {
    if (event) event.preventDefault()
    if (!this.hasDialogTarget) return
    this.dialogTarget.showModal()
    this.dialogTarget.addEventListener("click", this.boundCloseOnBackdrop)
  }

  close(event) {
    if (event) event.preventDefault()
    if (!this.hasDialogTarget) return
    this.dialogTarget.removeEventListener("click", this.boundCloseOnBackdrop)
    this.dialogTarget.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close(event)
  }
}
